var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('router-link',{staticClass:"mr-3 btn details_btn",attrs:{"to":_vm.$route.name == 'branch_invoice'
        ? {
            name: 'branch_invoice_details',
            query: _vm.$route.query.branchId
              ? {
                  id: _vm.data.id,
                  branchId: _vm.$route.query.branchId,
                  companyId: _vm.$route.query.companyId,
                }
              : { id: _vm.data.id, companyId: _vm.$route.query.companyId },
          }
        : _vm.$route.name == 'industrial_admin_invoice'
        ? {
            name: 'industrial_admin_invoice_details',
            query: { id: _vm.data.id, companyID: _vm.$route.query.companyID },
          }
        : {
            name: 'invoice_details',
            query: { id: _vm.data.id, companyId: _vm.$route.query.companyId },
          }}},[_vm._v("\n    "+_vm._s(_vm.$t("text.clickButtons.view"))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }